module.exports = __webpack_public_path__ + "roboto-bold-webfont.558f2a80d1f38d913b34.woff";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/assets/fonts/roboto-bold-webfont.woff
// module id = ../../../../../src/assets/fonts/roboto-bold-webfont.woff
// module chunks = styles